import { Container, Row, Col } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";
import mediumIcon from "../assets/img/medium.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <h1>BASUKI</h1>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a 
              href="https://www.linkedin.com/in/basuki-venkat-pati-6b50a81a9/" target="_blank" rel="noopener noreferrer">
                <img src={navIcon1} alt="Icon" />
              </a>
              <a href="https://medium.com/@bvp1020mu" 
                target="_blank" rel="noopener noreferrer">
                <img src={mediumIcon} alt="Icon" />
              </a>
            </div>
            <p>Copyright 2023. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
